module.exports = __webpack_public_path__ + "img/scgexpress.28a6a3ee.png";